import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
    labelKey: string;
    value?: string;
}

function NutritionModalRow({ labelKey, value }:Props) {
    const { t } = useTranslation('item');
    if (!value) {
        return (<Fragment/>);
    }
    return (
        <Container fullWidth justify='space-between'>
            <Text color={colors.gray7} fontWeight='medium'>
                {t(`nutrition.${labelKey}`)}
            </Text>
            <Text css={css`
                white-space: wrap;
                word-break: keep-all;
            `}>{value}</Text>
        </Container>
    );
}

const Container = styled(Row)`
    padding: 16px 0;
    border-bottom: 1px solid ${colors.gray2};
    &:nth-last-of-type(1) {
        border-bottom: none;
    }
`;

export default NutritionModalRow;
